/* JS for Brand Landing Page
   Included in sections via <script src="{{ 'brand-landing.js' | asset_url }}" defer="defer"></script>
*/

document.addEventListener('DOMContentLoaded', () => {

    // ---- Category Tabs Interactive ----
    const categoryTabs = document.querySelectorAll('.brand-category-tabs li');
    const featuredCards = document.querySelectorAll('#brandFeaturedGrid .brand-card');

    categoryTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            categoryTabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            const filterCat = tab.getAttribute('data-cat');
            featuredCards.forEach(card => {
                if (filterCat === 'all' || (card.getAttribute('data-cat') && card.getAttribute('data-cat').includes(filterCat))) {
                    card.style.display = 'block';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    });

    // ---- Alphabet Index Interactive ----
    const alphabetIndexes = document.querySelectorAll('.brand-alphabet-section .brand-alphabet-index span');
    const alphaCards = document.querySelectorAll('.brand-alphabetical-grid .brand-card');

    alphabetIndexes.forEach(letter => {
        letter.addEventListener('click', (e) => {
            const parent = e.target.parentElement;
            parent.querySelectorAll('span').forEach(s => s.classList.remove('active'));
            e.target.classList.add('active');

            const selectedLetter = e.target.textContent.trim().toUpperCase();

            alphaCards.forEach(card => {
                const brandName = card.querySelector('h4').textContent.trim().toUpperCase();
                if (brandName.startsWith(selectedLetter)) {
                    card.style.display = 'block';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    });

    // ---- Carousel Logic ----
    const track = document.getElementById('brandCarouselTrack');
    const prevBtn = document.getElementById('brandPrevBtn');
    const nextBtn = document.getElementById('brandNextBtn');
    const dots = document.querySelectorAll('.brand-carousel-dots .brand-dot');

    let currentIndex = 0;

    function updateCarousel() {
        if (!track) return;
        const cards = track.querySelectorAll('.brand-carousel-card');
        if (cards.length === 0) return;

        let cardToMeasure = cards[0];
        // Calculate the width of one card + its gap.
        const cardStyle = window.getComputedStyle(track);
        // The gap is set to 20px in our CSS, but let's grab it or hardcode.
        const gap = 20;
        const cardWidth = cardToMeasure.getBoundingClientRect().width;
        const totalMove = cardWidth + gap;

        // Ensure we don't go out of bounds
        track.style.transform = `translateX(-${currentIndex * totalMove}px)`;

        // Update dots (simple representation)
        dots.forEach((dot, index) => {
            if (index === currentIndex % dots.length) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
    }

    if (nextBtn && prevBtn) {
        nextBtn.addEventListener('click', () => {
            const cards = track.querySelectorAll('.brand-carousel-card');
            const visibleCards = window.innerWidth <= 768 ? (window.innerWidth <= 480 ? 1 : 2) : 4;

            if (currentIndex < cards.length - visibleCards) {
                currentIndex++;
                updateCarousel();
            } else {
                currentIndex = 0;
                updateCarousel();
            }
        });

        prevBtn.addEventListener('click', () => {
            if (currentIndex > 0) {
                currentIndex--;
            } else {
                const cards = track.querySelectorAll('.brand-carousel-card');
                const visibleCards = window.innerWidth <= 768 ? (window.innerWidth <= 480 ? 1 : 2) : 4;
                currentIndex = Math.max(0, cards.length - visibleCards);
            }
            updateCarousel();
        });
    }

    window.addEventListener('resize', updateCarousel);
});
